import { ISlideFactoryGeneric } from "../Slider/ISlideFactory";
import { SlotGameType1_2 } from "../SlotGameType1_2";

// import { ResourceManager } from "../../ResourceManager/ResourceManager";
import { FactoryDoubleSlide } from "../Slider/Slide2/FactoryDoubleSlide";
// import { SetStyles } from "../.././MyHelpers";


// namespace SlotGames2
// {
	export class LavaLand2 extends SlotGameType1_2
	{
		protected override seconScreenHelpFactory:ISlideFactoryGeneric = new FactoryDoubleSlide();
		////protected override freegameBonusFactory: FreegameBonusFactory2 = new LavaLandFreegame2BonusFactory();

		
		// public PrepareFont(resourceManager: ResourceManager)
		// {
		//  resourceManager.Add(new FontResource(this.basepath + "resources/montana.ttf",this.resid.ScopedResourceName(["BigSymbolFreegames2-font"])));
		// }
	}
// }